import { call, put } from 'redux-saga/effects';
import { fetchAccountsFailure, fetchAccountsSuccess } from '../actions';
import { FetchAccountsResponse, getAccounts } from '../api';
import { FetchAccountsRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { EntityAccount } from '../models';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchAccountsSaga(action: FetchAccountsRequestAction) {
  try {
    let err: ApiError | null;

    const { connectionId, mappingId } = action.payload;
    const response: FetchAccountsResponse = yield call(
      getAccounts,
      connectionId,
      mappingId
    );
    const entityAccounts: EntityAccount[] = response.data.accounts;

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(fetchAccountsSuccess(connectionId, entityAccounts));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchAccountsFailure());
  }
}
